import { put_service } from "..";
import { SubscribeCasting } from "../ApiEndpoints";


export const subscribeCasting = async (cast_id , userData={}) => {                        
  try {
    const headers = {};
    const response = await put_service(SubscribeCasting(cast_id), userData , headers);
    return response;
  } catch (error) {
    console.error('Error in subscribe a casting:', error);
    throw error;
  }
};

